module.exports = __webpack_public_path__ + "static/img/006 2.4fbfc2b9.jpg";